import './index.scss';
import {toJS} from 'mobx';
class Nav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            spread: props.spread || false
        };
    }

    toggleSpread = () => {
        this.setState({
            spread: !this.state.spread
        });
    }

    getSnapshotBeforeUpdate() {
        if (this.props.fixedTab === this.tab) {
            this.props.setFixedTabData && this.props.setFixedTabData({
                tabs: toJS(this.props.tabs),
                keyName: this.props.keyName,
                bg: this.props.bg,
                showFixed: true,
                spread: this.state.spread
            });
        }
    }

    render() {
        let {spread} = this.state;
        const {tabs = [], keyName = '', bg, showFixed, navCls = '',
            navClsAct = '', moreCls = '', nWrapCls = '', mode = 'more', tabMaxNum = 5, moreToActive = false} = this.props;
        // dbackCls = '',
        if (!tabs.length) return null;
        const activeIdx = tabs.findIndex(item => item.checked);
        let moreText = '更多';
        let moreActiveCls = '';
        if (moreToActive && activeIdx >= (tabMaxNum - 1)) {
            moreText = tabs.filter(item => item.checked)[0].title;
            moreActiveCls = 'active';
        }

        return (
            <div className={`m-nav-wrap ${showFixed ? 'fixed' : ''}`} ref={ele => this.tab = ele} style={{
                backgroundColor: bg
            }}>
                <div className={`m-nav ${nWrapCls} ${spread ? 'spread' : ''} ${tabs.length <= tabMaxNum ? 'min5' : ''}`} style={{
                    backgroundColor: bg
                }}>
                    {tabs.map((item, index) => {
                        if (tabs.length > tabMaxNum && mode === 'more') {
                            if (!spread && index > (tabMaxNum - 2)) return null;
                        }
                        return <div className={`m-nav-item ${navCls} ${item.checked ? `${navClsAct ? navClsAct : 'active'}` : ''}`} onClick={() => {
                            spread && this.toggleSpread();
                            this.props.tabClick(keyName, index);
                        }}>{item.title}</div>;
                    })}
                    {/* {<div className={`${dbackCls} drawback yo-ico`} onClick={this.toggleSpread} style={{
                        backgroundColor: bg
                    }}></div>} */}
                    {tabs.length <= tabMaxNum || mode === 'scroll' ? null : !spread ? <div className={`m-nav-item more-btn ${moreCls} ${moreActiveCls}`} onClick={this.toggleSpread}><i>{moreText}</i><span className="yo-ico"></span></div> : ''}
                </div>
            </div>
        );
    }
}

export default Nav;